import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import { useRightSidebarContext } from './RightSidebarContext';
import Content from './Content';

const RightSidebarContainer = ({ componentProps }) => {
  const { isInitializing } = useRightSidebarContext();

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      componentProps={componentProps}
    />
  );
};

RightSidebarContainer.defaultProps = {
  componentProps: {},
};

RightSidebarContainer.propTypes = {
  componentProps: PropTypes.object,
};

export default RightSidebarContainer;
